import type { ReactNode } from "react";
import { useParams } from "react-router";

/**
 * Restricción {Id:long} de las rutas del portal actual: un id que no es número no es la pantalla (queda la página sin
 * contenido, como cualquier dirección que no existe).
 */
export function NumericRoute({ element, param = "id" }: { element: ReactNode; param?: string }) {
  const value = useParams()[param];
  return value !== undefined && /^\d+$/.test(value) ? <>{element}</> : <div data-testid="portal-root" />;
}
